/** Columns the dashboard lets the user sort by (must match the backend's sortField handling). */
export const SORTABLE_FIELDS = [
  "venueState",
  "venueCity",
  "eventStart",
  "eventEnd",
  "daysTillStart",
  "daysTillEnd",
] as const;

export type SortableField = (typeof SORTABLE_FIELDS)[number];
